<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
     <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.sysGoodsLogMap">
            <div class="item">商品编码：{{form.beforeStr.sysGoodsLogMap.uuid}}</div>
            <div class="item">有无规格：{{form.beforeStr.sysGoodsLogMap.is_more_spec?'有':'无'}}</div>
            <div class="spec-title">价格信息：</div>
            <div class="item" v-if="form.beforeStr.combine && form.beforeStr.combine.length > 0">
              
              <div class="table-wrapper">
                <el-table :data="form.beforeStr.combine" border size="small">
                  <el-table-column label="规格名" prop="spec[0].name" align="center" >
                    <template slot-scope="{row}">
                      {{row.spec && row.spec.length > 0 ? row.spec[0].name : '-'}}
                    </template>
                  </el-table-column>
                  <el-table-column label="规格别名" prop="alias_title" align="center" ></el-table-column>
                  <el-table-column label="聚水潭规格编码" prop="jushuitan_code" align="center" ></el-table-column>
                  <el-table-column label="零售价" prop="retail_price" align="center" ></el-table-column>
                  <el-table-column label="总库存" prop="surplus_stock" align="center" ></el-table-column>
                  <el-table-column label="规格图" align="center" >
                    <template slot-scope="{row}">
                      <el-image 
                        v-if=" row.spec_img" 
                        style="width: 50px; height: 50px" 
                        :src="row.spec_img" 
                        :preview-src-list="[row.spec_img]">
                      </el-image>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="排序" prop="order_no" align="center" >
                    <template slot-scope="{row}">
                      {{row.spec && row.spec.length > 0 ? row.spec[0].order_no : row.order_no || '-'}}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="item">商品名称：{{form.beforeStr.sysGoodsLogMap.name}}</div>
            <div class="item">曾用名：{{form.beforeStr.sysGoodsLogMap.alias_name}}</div>
            <div class="item">供应商：{{form.beforeStr.sysGoodsLogMap.supplier}}</div>
            <div class="item">虚拟销售量：{{form.beforeStr.sysGoodsLogMap.virtual_sales_count}}</div>
            <div class="item">起购数量：{{form.beforeStr.sysGoodsLogMap.buy_min_count}}</div>
            <div class="item">APP是否显示：{{form.beforeStr.sysGoodsLogMap.is_show_app?'是':'否'}}</div>
            <div class="item">预计预售发货时间：{{form.beforeStr.sysGoodsLogMap.send_day}}天</div>
            <div class="item">商品主图：<el-image style="width: 50px; height: 50px" :src="form.beforeStr.sysGoodsLogMap.img" :preview-src-list="[form.beforeStr.sysGoodsLogMap.img]"></el-image></div>
            <div class="item">商品Banner图：
              <div v-if="form.beforeStr.sysGoodsLogMap.bannerImg">
                <el-image class="banner-box" v-for="(item,index) in form.beforeStr.sysGoodsLogMap.banner_img && form.beforeStr.sysGoodsLogMap.banner_img.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
              </div>
            </div>
            <div class="item">视频：
              <div v-if="form.beforeStr.sysGoodsLogMap.video">
                <video :autoplay="false" :controls="true" style="width: 100px;height: 50px;" :src="form.beforeStr.sysGoodsLogMap.video"></video>
              </div>
            </div>
            <div class="item">是否限制时间：{{form.beforeStr.sysGoodsLogMap.is_control_time?'限制':'不限制'}}</div>
            <div class="item" v-if="form.beforeStr.sysGoodsLogMap.listing_start_time && form.beforeStr.sysGoodsLogMap.listing_end_time">上下架时间：{{form.beforeStr.sysGoodsLogMap.listing_start_time}} ~ {{form.beforeStr.sysGoodsLogMap.listing_end_time}}</div>
            <div class="item">是否限购：{{form.beforeStr.sysGoodsLogMap.is_quota?'限购':'不限购'}}</div>
            <div class="item" v-if="form.beforeStr.sysGoodsLogMap.is_quota">限购数量：{{form.beforeStr.sysGoodsLogMap.quota_num}}</div>
            <div class="item">单位：{{form.beforeStr.sysGoodsLogMap.unit}}</div>
            <!-- REQ-2026-234328：产品规格。后端快照走 SELECT * 天然带出 product_spec，
                 之前只是这个白名单没列，属于「记了但看不到」 -->
            <!-- 注意：下面这个「商品标签」是老的自由文本标签(varchar500)，
                 和 REQ-2026-470053 的平台标签是两回事，别混 -->
            <div class="item">商品标签：{{form.beforeStr.sysGoodsLogMap.tag}}</div>
            <!-- REQ-2026-470053-8：平台标签明细。后端五条写入路径都已落库、快照也带了明细，
                 缺的只是这里没渲染 -->
            <div class="spec-title">平台标签：</div>
            <div class="item" v-if="form.beforeStr.platformTagList && form.beforeStr.platformTagList.length > 0">
              <div class="table-wrapper">
                <el-table :data="form.beforeStr.platformTagList" border size="small">
                  <el-table-column label="标签" align="center">
                    <template slot-scope="{row}">{{platformTagName(row.tag_code)}}</template>
                  </el-table-column>
                  <el-table-column label="来源" align="center">
                    <template slot-scope="{row}">{{platformTagSource(row.source)}}</template>
                  </el-table-column>
                  <el-table-column label="操作原因" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">{{row.reason || '-'}}</template>
                  </el-table-column>
                  <el-table-column label="生效时间" prop="effective_at" align="center"></el-table-column>
                  <el-table-column label="失效时间" prop="expired_at" align="center"></el-table-column>
                  <el-table-column label="状态" align="center">
                    <template slot-scope="{row}">{{platformTagStatus(row.status)}}</template>
                  </el-table-column>
                  <el-table-column label="操作人" prop="operated_by" align="center"></el-table-column>
                  <el-table-column label="操作时间" prop="operated_time" align="center"></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="item" v-else>-</div>
            <div class="item" v-if="form.beforeStr.sysGoodsLogMap.details">商品详情：<div v-html="form.beforeStr.sysGoodsLogMap.details"></div>
            </div>
            <div class="item" v-if="form.beforeStr.sysGoodsLogMap.qualification">商品资质：<div v-html="form.beforeStr.sysGoodsLogMap.qualification"></div>
            </div>
            <div class="item">商品排序：{{form.beforeStr.sysGoodsLogMap.sort}}</div>
            <div class="item">是否设为推荐商品：{{form.beforeStr.sysGoodsLogMap.is_top_recommend?'是':'否'}}</div>
            <div class="item">是否包邮：{{form.beforeStr.sysGoodsLogMap.is_postage?'包邮':'不包邮'}}</div>
            <div class="item">状态：{{form.beforeStr.sysGoodsLogMap.state?'启用':'禁用'}}</div>
            <div class="item">是否开票：{{form.afterStr.sysGoodsLogMap.can_invoice==1?'是':'否'}}</div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.sysGoodsLogMap">
            <div class="item">商品编码：{{form.afterStr.sysGoodsLogMap.uuid}}</div>
            <div class="item">有无规格：{{form.afterStr.sysGoodsLogMap.is_more_spec?'有':'无'}}</div>
            <div class="spec-title">价格信息：</div>
            <div class="item" v-if="form.afterStr.combine && form.afterStr.combine.length > 0">
              
              <div class="table-wrapper">
                <el-table :data="form.afterStr.combine" border size="small" style="margin-top: 10px;">
                  <el-table-column label="规格名" prop="spec[0].name" align="center">
                    <template slot-scope="{row}">
                      {{row.spec && row.spec.length > 0 ? row.spec[0].name : '-'}}
                    </template>
                  </el-table-column>
                  <el-table-column label="规格别名" prop="alias_title" align="center" ></el-table-column>
                  <el-table-column label="聚水潭规格编码" prop="jushuitan_code" align="center" ></el-table-column>
                  <el-table-column label="价格" prop="retail_price" align="center" ></el-table-column>
                  <el-table-column label="总库存" prop="surplus_stock" align="center" ></el-table-column>
                  <el-table-column label="规格图" align="center">
                    <template slot-scope="{row}">
                      <el-image 
                        v-if=" row.spec_img" 
                        style="width: 50px; height: 50px" 
                        :src="row.spec_img" 
                        :preview-src-list="[row.spec_img]">
                      </el-image>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="排序" prop="order_no" align="center" >
                    <template slot-scope="{row}">
                      {{row.spec && row.spec.length > 0 ? row.spec[0].order_no : row.order_no || '-'}}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="item">商品名称：{{form.afterStr.sysGoodsLogMap.name}}</div>
            <div class="item">曾用名：{{form.afterStr.sysGoodsLogMap.alias_name}}</div>
            <div class="item">供应商：{{form.afterStr.sysGoodsLogMap.supplier}}</div>
            <div class="item">虚拟销售量：{{form.afterStr.sysGoodsLogMap.virtual_sales_count}}</div>
            <div class="item">起购数量：{{form.afterStr.sysGoodsLogMap.buy_min_count}}</div>
            <div class="item">APP是否显示：{{form.afterStr.sysGoodsLogMap.is_show_app?'是':'否'}}</div>
            <div class="item">预计预售发货时间：{{form.afterStr.sysGoodsLogMap.send_day}}天</div>
            <div class="item">商品主图：<el-image style="width: 50px; height: 50px" :src="form.afterStr.sysGoodsLogMap.img" :preview-src-list="[form.afterStr.sysGoodsLogMap.img]"></el-image></div>
            <div class="item">商品Banner图：
              <div v-if="form.afterStr.sysGoodsLogMap.bannerImg">
                <el-image class="banner-box" v-for="(item,index) in form.afterStr.sysGoodsLogMap.banner_img && form.afterStr.sysGoodsLogMap.banner_img.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
              </div>
            </div>
            <div class="item">视频：
              <div v-if="form.afterStr.sysGoodsLogMap.video">
                <video :autoplay="false" :controls="true" style="width: 100px;height: 50px;" :src="form.afterStr.sysGoodsLogMap.video"></video>
              </div>
            </div>
            <div class="item">是否限制时间：{{form.afterStr.sysGoodsLogMap.is_control_time?'限制':'不限制'}}</div>
            <div class="item" v-if="form.afterStr.sysGoodsLogMap.listing_start_time && form.afterStr.sysGoodsLogMap.listing_end_time">上下架时间：{{form.afterStr.sysGoodsLogMap.listing_start_time}} ~ {{form.afterStr.sysGoodsLogMap.listing_end_time}}</div>
            <div class="item">是否限购：{{form.afterStr.sysGoodsLogMap.is_quota?'限购':'不限购'}}</div>
            <div class="item" v-if="form.afterStr.sysGoodsLogMap.is_quota">限购数量：{{form.afterStr.sysGoodsLogMap.quota_num}}</div>
            <div class="item">单位：{{form.afterStr.sysGoodsLogMap.unit}}</div>
            <!-- REQ-2026-234328：产品规格。后端快照走 SELECT * 天然带出 product_spec，
                 之前只是这个白名单没列，属于「记了但看不到」 -->
            <!-- 注意：下面这个「商品标签」是老的自由文本标签(varchar500)，
                 和 REQ-2026-470053 的平台标签是两回事，别混 -->
            <div class="item">商品标签：{{form.afterStr.sysGoodsLogMap.tag}}</div>
            <!-- REQ-2026-470053-8：平台标签明细。后端五条写入路径都已落库、快照也带了明细，
                 缺的只是这里没渲染 -->
            <div class="spec-title">平台标签：</div>
            <div class="item" v-if="form.afterStr.platformTagList && form.afterStr.platformTagList.length > 0">
              <div class="table-wrapper">
                <el-table :data="form.afterStr.platformTagList" border size="small">
                  <el-table-column label="标签" align="center">
                    <template slot-scope="{row}">{{platformTagName(row.tag_code)}}</template>
                  </el-table-column>
                  <el-table-column label="来源" align="center">
                    <template slot-scope="{row}">{{platformTagSource(row.source)}}</template>
                  </el-table-column>
                  <el-table-column label="操作原因" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">{{row.reason || '-'}}</template>
                  </el-table-column>
                  <el-table-column label="生效时间" prop="effective_at" align="center"></el-table-column>
                  <el-table-column label="失效时间" prop="expired_at" align="center"></el-table-column>
                  <el-table-column label="状态" align="center">
                    <template slot-scope="{row}">{{platformTagStatus(row.status)}}</template>
                  </el-table-column>
                  <el-table-column label="操作人" prop="operated_by" align="center"></el-table-column>
                  <el-table-column label="操作时间" prop="operated_time" align="center"></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="item" v-else>-</div>
            <div class="item" v-if="form.afterStr.sysGoodsLogMap.details">商品详情：<div v-html="form.afterStr.sysGoodsLogMap.details"></div>
            </div>
            <div class="item" v-if="form.afterStr.sysGoodsLogMap.qualification">商品资质：<div v-html="form.afterStr.sysGoodsLogMap.qualification"></div>
            </div>
            <div class="item">商品排序：{{form.afterStr.sysGoodsLogMap.sort}}</div>
            <div class="item">是否设为推荐商品：{{form.afterStr.sysGoodsLogMap.is_top_recommend?'是':'否'}}</div>
            <div class="item">是否包邮：{{form.afterStr.sysGoodsLogMap.is_postage?'包邮':'不包邮'}}</div>
            <div class="item">状态：{{form.afterStr.sysGoodsLogMap.state?'启用':'禁用'}}</div>
            <div class="item">是否开票：{{form.afterStr.sysGoodsLogMap.can_invoice==1?'是':'否'}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    },
    platformTagName(value) {
      return { NEW: '平台新品', HOT: '平台爆款' }[value] || value || '-'
    },
    platformTagSource(value) {
      return { AUTO: '自动', MANUAL: '人工' }[value] || value || '-'
    },
    platformTagStatus(value) {
      const map = { 0: '已取消', 1: '有效', 2: '已过期' }
      return map[value] === undefined ? '-' : map[value]
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.spec-title {
  font-weight: 500;
  margin-bottom: 5px;
}
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  .el-table {
    max-width: 85%;
  }
}
</style>
